var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.4 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Door knob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.3 29.7c-0.9 0-1.7 0.4-2.3 1.1-0.5 0.6-0.7 1.5-0.5 2.4l1.3 4.2c0.2 0.7 0.9 1.2 1.6 1.2s1.4-0.5 1.4-1.1l1.3-4.3c0.2-0.8 0-1.7-0.5-2.4-0.6-0.7-1.4-1.1-2.3-1.1zm2 3.2l-1.3 4.3c0 0.2-0.3 0.4-0.5 0.4s-0.4-0.2-0.5-0.4l-1.3-4.3c-0.2-0.5 0-1.1 0.3-1.5s0.8-0.7 1.4-0.7c0.5 0 1.1 0.2 1.6 0.8 0.3 0.4 0.4 0.9 0.3 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.3 0.2h-17.9c-2.8 0-5.1 2.4-5.1 5.2v4.6h-11.3c-2.2 0-4 1.8-4 4v1c0 2.2 1.8 4 4 4h11.3v23.6c0 2.9 2.3 5.2 5.2 5.2h17.7c2.9 0 5.2-2.3 5.2-5.2v-37.2c0-2.8-2.3-5.2-5.1-5.2zm-34.3 17.2c-1.2 0-2.2-1.1-2.2-2.3v-1c0-1.2 1-2.3 2.3-2.3h25.7c1.2 0 2.3 1 2.3 2.3v1c0 1.2-1 2.3-2.3 2.3h-25.8zm25.7-7.4h-5.1c1.3-1.3 3-2 5-2 3.9 0 7.1 3.2 7.1 7.1s-3.2 7.1-7.1 7.1c-2.4 0-4.4-1.3-5.7-3.2h5.8c2.2 0 4-1.8 4-4v-1c0-2.2-1.8-4-4-4zm12 32.7c0 1.9-1.6 3.5-3.5 3.5h-17.7c-1.9 0-3.5-1.6-3.5-3.5v-23.7h4.7c1.5 2.9 4.5 5 8 5 4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9c-3.2 0-5.8 1.5-7.5 3.8h-5.2v-4.6c0-1.9 1.6-3.5 3.5-3.5h17.7c1.9 0 3.5 1.6 3.5 3.5v37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyEntry);
export default __webpack_public_path__ + "static/media/key-entry.bf8f1bbfa655931097e0e5d3532c794e.svg";
export { ForwardRef as ReactComponent };